<template>
  <div id="nav">
    <router-link :to="{ name: 'AlbumsIndividual' }">Individual</router-link> |
    <router-link :to="{ name: 'AlbumsMassive' }">Massive</router-link>
  </div>
</template>

<script>
export default {
  name: "AppHeader",

  methods: {
    logout() {
      localStorage.clear()
      this.$router.push({ name: 'Login' })
    }
  }
}
</script>

<style scoped>
  button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    text-decoration: underline;
    padding: 0;
  }
</style>
